<template>
  <div>
    <transition name="fade">
      <div
        v-show="show_drawer"
        class="overlay"
        @click="hideDrawer"
      />
    </transition>

    <div
      v-if="!isInternationalUser"
      :class="show_drawer ? 'translate0' : 'translate-100'"
      class="drawer"
    >
      <div
        class="cross"
        @click="closeDrawer"
      >
        <i
          class="fa fa-times"
        />
      </div>
      <div
        v-if="!isLoggedIn"
        class="logo"
      >
        <router-link
          :class="{'disabled' : disable_menu}"
          to="/"
          @click.native="closeDrawer"
        >
          <img
            class="img-fluid"
            src="../assets/images/Luminary-logo.svg"
          >
        </router-link>
      </div>
      <div
        class="sub-menu"
      >
        <router-link
          v-if="isLoggedIn || onListenRoute"
          to="/listen"
          class="link has-active-state"
          @click.native="closeDrawer"
        >
          <svg class="icon" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"><defs><path id="ic_discover_darkgray_svg__a" d="M4.0520743 5.6769652L5 18h10l.9477921-12.3212973L9.996094 2.269287 4.0520743 5.6769652zm13.8288527 1.109129L17 20H3L2.119012 6.7851805 0 8V6l10-6 10 6v2l-2.119073-1.2139057z"/></defs><g fill="none" fill-rule="evenodd" transform="translate(2 2)"><mask id="ic_discover_darkgray_svg__b" fill="#fff"><use xlink:href="#ic_discover_darkgray_svg__a"/></mask><g fill="#111" mask="url(#ic_discover_darkgray_svg__b)"><path d="M-2-2h24v24H-2z"/></g></g></svg>
          <span class="menu-text">Home</span>
        </router-link>
        <router-link
          v-if="isLoggedIn || onListenRoute"
          to="/listen/search"
          class="link has-active-state"
          @click.native="closeDrawer"
        >
          <svg class="icon" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"><defs><path id="ic_search_darkgray_svg__a" d="M15.1797038 13.7571474l4.7528058 4.7726378-1.4142135 1.4142135-4.7518254-4.7716533C12.3184422 16.3168321 10.4890023 17 8.5 17 3.8055796 17 0 13.1944204 0 8.5S3.8055796 0 8.5 0 17 3.8055796 17 8.5c0 1.9847359-.6802402 3.8105932-1.8202962 5.2571474zM8.5 15c3.5898509 0 6.5-2.9101491 6.5-6.5S12.0898509 2 8.5 2 2 4.9101491 2 8.5 4.9101491 15 8.5 15z"/></defs><g fill="none" fill-rule="evenodd" transform="translate(2 2)"><mask id="ic_search_darkgray_svg__b" fill="#fff"><use xlink:href="#ic_search_darkgray_svg__a"/></mask><use fill="#9A9A9A" fill-rule="nonzero" xlink:href="#ic_search_darkgray_svg__a"/><g fill="#111" mask="url(#ic_search_darkgray_svg__b)"><path d="M-2-2h24v24H-2z"/></g></g></svg>
          <span class="menu-text">Search</span>
        </router-link>
        <router-link
          v-if="isLoggedIn"
          to="/listen/my-shows"
          class="link has-active-state"
          @click.native="closeDrawer"
        >
          <svg class="icon" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"><defs><path id="ic_myshows_darkgray_svg__a" d="M17.9999777 9.799699C19.2144353 10.5294648 20 11.6913443 20 13c0 2.2091304-2.238587 4-5 4V9c.3424549 0 .6768689.0275428.9999696.0800104a190061.1483155 190061.1483155 0 0 0-.000013-1.0725086C15.9875331 4.6954085 13.2968924 2 10 2 6.6862915 2 4 4.6862915 4 8v1.0800153C4.3231102 9.0275445 4.6575344 9 5 9v8c-2.761413 0-5-1.7908696-5-4 0-1.3086475.785555-2.4705208 2-3.2002877V8c0-4.418278 3.581722-8 8-8 4.4080562 0 7.9834227 3.5958203 7.9999425 8 .0000144.0038456.0000262.8035242.0000352 1.799699z"/></defs><g fill="none" fill-rule="evenodd" transform="translate(2 4)"><mask id="ic_myshows_darkgray_svg__b" fill="#fff"><use xlink:href="#ic_myshows_darkgray_svg__a"/></mask><g fill="#111" mask="url(#ic_myshows_darkgray_svg__b)"><path d="M-2-4h24v24H-2z"/></g></g></svg>
          <span class="menu-text">My Shows</span>
        </router-link>
        <router-link
          v-if="!isLoggedIn && !onListenRoute"
          to="/"
          class="link"
          @click.native="downloadMobileApp"
        >
          <span class="menu-text">Download</span>
        </router-link>
        <router-link
          v-if="!isLoggedIn && !onListenRoute"
          to="/shows"
          class="link"
          @click.native="closeDrawer"
        >
          <span class="menu-text">Luminary Originals</span>
        </router-link>
      </div>
      <div
        v-if="onListenRoute && !isPremiumUser"
        class="sub-menu"
      >
        <router-link
          to="/premium"
          class="link"
          @click.native="closeDrawer"
        >
          <span
            class="menu-text"
          >Go Premium</span>
        </router-link>
      </div>
      <div class="sub-menu">
        <router-link
          v-if="isLoggedIn"
          to="/account/info"
          class="link"
          @click.native="closeDrawer"
        >
          <span class="menu-text">My Account</span>
        </router-link>
        <a
          v-if="isLoggedIn"
          class="link"
          @click="logout"
        >
          <span class="menu-text">Sign out</span>
        </a>
        <router-link
          v-if="!isLoggedIn"
          to="/signup"
          class="link"
          @click.native="closeDrawer"
        >
          <span class="menu-text">Sign up</span>
        </router-link>
        <router-link
          v-if="!isLoggedIn"
          to="/signin"
          class="link"
          @click.native="closeDrawer"
        >
          <span class="menu-text">Log in</span>
        </router-link>
      </div>
    </div>

    <div
      class="app-navbar"
      data-test="navbar"
    >
      <div
        class="container"
      >
        <div
          v-if="!isInternationalUser"
          class="hamburger-menu"
          @click="showDrawer"
        >
          <i class="fa fa-bars" />
        </div>
        <div class="logo">
          <router-link
            :class="{'disabled' : disable_menu}"
            :to="isInternationalUser ? '/international' : '/'"><img
              class="img-fluid"
              src="../assets/images/Luminary-logo.svg"
              alt=""
            >
          </router-link>
        </div>
        <div
          v-if="showHomeAndSearchLinks"
          class="tabs-menu">
          <el-menu
            :class="{'d-none':hide_menu}"
            :router="false"
            :default-active="defaultTab"
            mode="horizontal"
          >
            <el-menu-item
              :disabled="disable_menu"
              index="1"
              @click="redirect('/listen')"
            >
              <a>
                <img src="../assets/images/ic_discover_darkgray.svg">
                <span class="menu-text">Home</span>
              </a>
            </el-menu-item>
            <el-menu-item
              :disabled="disable_menu"
              index="2"
              @click="redirect('/listen/search')"
            >
              <a>
                <img src="../assets/images/ic_search_darkgray.svg">
                <span class="menu-text">Search</span>
              </a>
            </el-menu-item>
            <el-menu-item
              v-if="isLoggedIn"
              :disabled="disable_menu"
              index="3"
              @click="redirect('/listen/my-shows')"
            >
              <a>
                <img src="../assets/images/ic_myshows_darkgray.svg">
                <span class="menu-text"> My Shows </span>
              </a>
            </el-menu-item>
            <el-menu-item
              index="4"
              class="d-none"
            />
          </el-menu>
        </div>
        <div
          v-if="!isInternationalUser"
          class="right-menu">
          <el-row
            type="flex"
            align="middle"
            justify="end"
          >
            <div
              v-if="!onListenRoute"
              class="link-menu listen"
            >
              <router-link
                class="link"
                to="/listen"
              >
                Listen
              </router-link>
              <router-link
                class="link"
                to="/shows"
              >
                Luminary Originals
              </router-link>
            </div>
            <div
              v-if="(onListenRoute && !isPremiumUser)"
              class="link-menu go-premium"
            >
              <router-link
                class="link"
                to="/premium"
                data-test="btn-premium">
                Go Premium
              </router-link>
            </div>
            <div class="link-menu auth">
              <router-link
                v-if="!isLoggedIn"
                class="link"
                to="/signup"
                data-test="btn-signupheader"
              >
                Sign up
              </router-link>
              <router-link
                v-if="!isLoggedIn"
                class="link"
                to="/signin"
              >
                Log In
              </router-link>
              <el-dropdown
                v-if="isLoggedIn"
                :trigger="isTouchDevice ? 'click' : 'hover'"
                class="user-avatar-menu-desktop"
              >
                <span class="el-dropdown-link">
                  <svg v-if="user.is_subscribed" svg-inline="" class="profile-pic" data-test="icon-usersubscribed" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_authuser_premium_svg__a" d="M12,0 C5.373,0 0,5.373 0,12 L0,12 C0,18.62775 5.373,24 12,24 L12,24 C18.627,24 23.99925,18.62775 23.99925,12 L23.99925,12 C23.99925,5.373 18.627,0 12,0 Z"/><polygon id="ic_authuser_premium_svg__c" points="0 0 23.9997 0 23.9997 24 0 24"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-91.000000, -797.000000) translate(91.000000, 796.992335)"><mask id="ic_authuser_premium_svg__b" fill="white"><use xlink:href="#ic_authuser_premium_svg__a"/></mask><g mask="url(#ic_authuser_premium_svg__b)"><g><mask id="ic_authuser_premium_svg__d" fill="white"><use xlink:href="#ic_authuser_premium_svg__c"/></mask><g fill="#FFE500" mask="url(#ic_authuser_premium_svg__d)"><rect width="24" height="24"/></g></g><path fill="#777774" d="M15.841275,10.655625 C15.841275,12.777375 14.121525,14.497125 11.999775,14.497125 C9.878775,14.497125 8.158275,12.777375 8.158275,10.655625 C8.158275,8.533875 9.878775,6.814125 11.999775,6.814125 C14.121525,6.814125 15.841275,8.533875 15.841275,10.655625"/><path stroke="#111111" stroke-width="1.5" d="M5.723925,12.2556 L5.723925,9.9726 C5.723925,7.0221 7.948425,3.6621 12.035175,3.6621 C16.664175,3.6621 18.346425,7.0221 18.346425,9.9726 L18.346425,12.2556"/><path fill="#111111" d="M17.047575,14.770725 C19.250325,14.466975 20.919825,13.763475 20.919825,11.085975 C20.919825,8.216475 19.228575,8.508975 17.024325,8.220975 L17.047575,14.770725 Z"/><path fill="#111111" d="M7.13235,7.428225 C4.9296,7.731975 3.2541,9.266475 3.2601,11.112975 C3.2661,12.959475 4.95135,14.481975 7.1556,14.770725 L7.13235,7.428225 Z"/></g><g fill="#777774" mask="url(#ic_authuser_premium_svg__b)"><g><path d="M16.7675,9.75 C16.09625,4.3935 12.6335,0.309 8.45075,0.309 C4.26725,0.309 0.8045,4.3935 0.13325,9.75 L16.7675,9.75 Z" transform="translate(4.000000, 15.000000)"/></g></g></g></g></g></g></svg>
                  <svg v-else="" svg-inline="" class="profile-pic" data-test="icon-user" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_authuser_svg__a" d="M12,0 C5.373,0 0,5.373 0,12 L0,12 C0,18.62775 5.373,24 12,24 L12,24 C18.627,24 23.99925,18.62775 23.99925,12 L23.99925,12 C23.99925,5.373 18.627,0 12,0 Z"/><polygon id="ic_authuser_svg__c" points="0 0 23.9997 0 23.9997 24 0 24"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-45.000000, -797.000000) translate(45.000000, 796.992335)"><mask id="ic_authuser_svg__b" fill="white"><use xlink:href="#ic_authuser_svg__a"/></mask><g mask="url(#ic_authuser_svg__b)"><g><mask id="ic_authuser_svg__d" fill="white"><use xlink:href="#ic_authuser_svg__c"/></mask><path fill="#BBBBBB" d="M23.9997,12 C23.9997,18.62775 18.62745,24 11.9997,24 C5.3727,24 -0.0003,18.62775 -0.0003,12 C-0.0003,5.373 5.3727,0 11.9997,0 C18.62745,0 23.9997,5.373 23.9997,12" mask="url(#ic_authuser_svg__d)"/></g><path fill="#777774" d="M15.841275,10.655625 C15.841275,12.777375 14.121525,14.497125 11.999775,14.497125 C9.878775,14.497125 8.158275,12.777375 8.158275,10.655625 C8.158275,8.533875 9.878775,6.814125 11.999775,6.814125 C14.121525,6.814125 15.841275,8.533875 15.841275,10.655625"/><path stroke="#111111" stroke-width="1.5" d="M5.723925,12.2556 L5.723925,9.9726 C5.723925,7.0221 7.948425,3.6621 12.035175,3.6621 C16.664175,3.6621 18.346425,7.0221 18.346425,9.9726 L18.346425,12.2556"/><path fill="#111111" d="M17.047575,14.770725 C19.250325,14.466975 20.919825,13.763475 20.919825,11.085975 C20.919825,8.216475 19.228575,8.508975 17.024325,8.220975 L17.047575,14.770725 Z"/><path fill="#111111" d="M7.13235,7.428225 C4.9296,7.731975 3.2541,9.266475 3.2601,11.112975 C3.2661,12.959475 4.95135,14.481975 7.1556,14.770725 L7.13235,7.428225 Z"/></g><g fill="#777774" mask="url(#ic_authuser_svg__b)"><g><path d="M16.7675,9.75 C16.09625,4.3935 12.6335,0.309 8.45075,0.309 C4.26725,0.309 0.8045,4.3935 0.13325,9.75 L16.7675,9.75 Z" transform="translate(4.000000, 15.000000)"/></g></g></g></g></g></g></svg>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  :disabled="disable_menu"
                  :append-to-body="false"
                  data-test="option-menu"
                >
                  <el-dropdown-item>
                    <span v-if="user && user.email"> Hi,</span>
                    <span class="capitalize"> {{ user && user.email ? user.email.substring(0, user.email.indexOf('@')) : 'User Name' }} </span>
                    <span class="arrow"><i class="el-icon-arrow-up" /></span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    data-test="option-menu"
                    @click.native="navigateToMyAccount"
                  >
                    My Account
                  </el-dropdown-item>
                  <el-dropdown-item
                    data-test="option-menu"
                    @click.native="logout"
                  >
                    Sign Out
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-row>
        </div>
        <el-dropdown
          v-if="isLoggedIn && !isInternationalUser"
          trigger="click"
          class="user-avatar-menu"
        >
          <span class="el-dropdown-link">
            <svg v-if="user.is_subscribed" svg-inline="" class="profile-pic" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_authuser_premium_svg__a" d="M12,0 C5.373,0 0,5.373 0,12 L0,12 C0,18.62775 5.373,24 12,24 L12,24 C18.627,24 23.99925,18.62775 23.99925,12 L23.99925,12 C23.99925,5.373 18.627,0 12,0 Z"/><polygon id="ic_authuser_premium_svg__c" points="0 0 23.9997 0 23.9997 24 0 24"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-91.000000, -797.000000) translate(91.000000, 796.992335)"><mask id="ic_authuser_premium_svg__b" fill="white"><use xlink:href="#ic_authuser_premium_svg__a"/></mask><g mask="url(#ic_authuser_premium_svg__b)"><g><mask id="ic_authuser_premium_svg__d" fill="white"><use xlink:href="#ic_authuser_premium_svg__c"/></mask><g fill="#FFE500" mask="url(#ic_authuser_premium_svg__d)"><rect width="24" height="24"/></g></g><path fill="#777774" d="M15.841275,10.655625 C15.841275,12.777375 14.121525,14.497125 11.999775,14.497125 C9.878775,14.497125 8.158275,12.777375 8.158275,10.655625 C8.158275,8.533875 9.878775,6.814125 11.999775,6.814125 C14.121525,6.814125 15.841275,8.533875 15.841275,10.655625"/><path stroke="#111111" stroke-width="1.5" d="M5.723925,12.2556 L5.723925,9.9726 C5.723925,7.0221 7.948425,3.6621 12.035175,3.6621 C16.664175,3.6621 18.346425,7.0221 18.346425,9.9726 L18.346425,12.2556"/><path fill="#111111" d="M17.047575,14.770725 C19.250325,14.466975 20.919825,13.763475 20.919825,11.085975 C20.919825,8.216475 19.228575,8.508975 17.024325,8.220975 L17.047575,14.770725 Z"/><path fill="#111111" d="M7.13235,7.428225 C4.9296,7.731975 3.2541,9.266475 3.2601,11.112975 C3.2661,12.959475 4.95135,14.481975 7.1556,14.770725 L7.13235,7.428225 Z"/></g><g fill="#777774" mask="url(#ic_authuser_premium_svg__b)"><g><path d="M16.7675,9.75 C16.09625,4.3935 12.6335,0.309 8.45075,0.309 C4.26725,0.309 0.8045,4.3935 0.13325,9.75 L16.7675,9.75 Z" transform="translate(4.000000, 15.000000)"/></g></g></g></g></g></g></svg>
            <svg v-else="" svg-inline="" class="profile-pic" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_authuser_svg__a" d="M12,0 C5.373,0 0,5.373 0,12 L0,12 C0,18.62775 5.373,24 12,24 L12,24 C18.627,24 23.99925,18.62775 23.99925,12 L23.99925,12 C23.99925,5.373 18.627,0 12,0 Z"/><polygon id="ic_authuser_svg__c" points="0 0 23.9997 0 23.9997 24 0 24"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-45.000000, -797.000000) translate(45.000000, 796.992335)"><mask id="ic_authuser_svg__b" fill="white"><use xlink:href="#ic_authuser_svg__a"/></mask><g mask="url(#ic_authuser_svg__b)"><g><mask id="ic_authuser_svg__d" fill="white"><use xlink:href="#ic_authuser_svg__c"/></mask><path fill="#BBBBBB" d="M23.9997,12 C23.9997,18.62775 18.62745,24 11.9997,24 C5.3727,24 -0.0003,18.62775 -0.0003,12 C-0.0003,5.373 5.3727,0 11.9997,0 C18.62745,0 23.9997,5.373 23.9997,12" mask="url(#ic_authuser_svg__d)"/></g><path fill="#777774" d="M15.841275,10.655625 C15.841275,12.777375 14.121525,14.497125 11.999775,14.497125 C9.878775,14.497125 8.158275,12.777375 8.158275,10.655625 C8.158275,8.533875 9.878775,6.814125 11.999775,6.814125 C14.121525,6.814125 15.841275,8.533875 15.841275,10.655625"/><path stroke="#111111" stroke-width="1.5" d="M5.723925,12.2556 L5.723925,9.9726 C5.723925,7.0221 7.948425,3.6621 12.035175,3.6621 C16.664175,3.6621 18.346425,7.0221 18.346425,9.9726 L18.346425,12.2556"/><path fill="#111111" d="M17.047575,14.770725 C19.250325,14.466975 20.919825,13.763475 20.919825,11.085975 C20.919825,8.216475 19.228575,8.508975 17.024325,8.220975 L17.047575,14.770725 Z"/><path fill="#111111" d="M7.13235,7.428225 C4.9296,7.731975 3.2541,9.266475 3.2601,11.112975 C3.2661,12.959475 4.95135,14.481975 7.1556,14.770725 L7.13235,7.428225 Z"/></g><g fill="#777774" mask="url(#ic_authuser_svg__b)"><g><path d="M16.7675,9.75 C16.09625,4.3935 12.6335,0.309 8.45075,0.309 C4.26725,0.309 0.8045,4.3935 0.13325,9.75 L16.7675,9.75 Z" transform="translate(4.000000, 15.000000)"/></g></g></g></g></g></g></svg>
          </span>
          <el-dropdown-menu
            slot="dropdown"
            :disabled="disable_menu"
            :append-to-body="false"
          >
            <el-dropdown-item>
              <span v-if="user && user.email"> Hi,</span>
              <span class="capitalize"> {{ user && user.email ? user.email.substring(0, user.email.indexOf('@')) : 'User Name' }} </span>
              <span class="arrow"><i class="el-icon-arrow-up" /></span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="navigateToMyAccount">
              My Account
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">
              Sign Out
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';
import User from '../services/User';

export default {
  name: 'Navbar',
  data() {
    return {
      userProvider: new User(),
      hide_menu: false,
      defaultTab: '',
      hidden: false,
      disabled_paths: ['/user-info', '/user-categories', '/user-shows', '/complete'],
      active_tabs: {
        '/listen/my-shows': { activeTab: '3' }, '/listen/bookmarks': { activeTab: '3' }, '/listen/my-shows/list': { activeTab: '3' }, '/listen/search': { activeTab: '2' }, '/listen': { activeTab: '1' }, '': { activeTab: '1' },
      },
      current_width: window.innerWidth,
      show_drawer: false,
    };
  },
  computed: {
    isTouchDevice() {
      return window.isTouch;
    },
    isLoggedIn() {
      const { user } = this.$store.getters;
      const { token } = this.$store.getters;

      const loggedIn = token && token.length && user && user.uuid;
      return loggedIn;
    },
    onListenRoute() {
      return this.$route.path.includes('/listen') || this.$route.path.includes('/premium');
    },
    showHomeAndSearchLinks() {
      if (this.isInternationalUser) {
        return false;
      }

      const hideOnPage = path => ['/', '/shows', '/international'].includes(path);
      return this.isLoggedIn || !hideOnPage(this.$route.path);
    },
    isPremiumUser() {
      const { user } = this.$store.getters;

      return user && user.uuid && user.is_subscribed;
    },
    user() {
      return this.$store.getters.user;
    },
    disable_menu() {
      // return this.disabled_paths.includes(this.$route.path);
      return false;
    },
  },
  watch: {
    $route(to, from) {
      this.setUserRedirectPath(to, from);
      this.hidePremiumButton();
      this.setDefaultTab();
      this.hidePlayer();
    },
    user() {
      this.updateAppStyle();
    },
    show_drawer() {
      // Hide scrolling when overlay is shown.
      if (this.show_drawer) this.disableVerticalScroll();
      else this.enableVerticalScroll();
    },
  },
  mounted() {
    this.setDefaultTab();
    this.hidePremiumButton();
    this.updateAppStyle();
    window.onresize = () => {
      this.updateAppStyle();
    };
  },
  methods: {
    downloadMobileApp() {
      const branchBaseLink = process.env.LUMINARY_BRANCH_IO_BASE_LINK || window.location.hostname || '';
      window.open(branchBaseLink);

      this.closeDrawer();
    },
    hidePlayer() {
      if (this.$route.path.includes('signin') || this.$route.path.includes('signup') || this.$route.path.includes('forgotPassword') || this.disabled_paths.includes(this.$route.path)) window.eventBus.$emit('hide-player');
    },
    hideDrawer() {
      this.show_drawer = false;
    },
    setUserRedirectPath(to, from) {
      // Reset redirect path, if user navigates from signup to any other page than the next onboarding one.
      if ((from.path.includes('/sign-up') || from.path.includes('/sign-in')) && !to.path.includes('/user-info')) {
        this.$store.dispatch('setRedirectPath', null);
      }
      // Set user redirect path if they navigate from either EDP or SDP to signup page.
      if ((from.path.includes('/listen')) && (to.path.includes('/signup') || to.path.includes('/signin'))) {
        log.info('Redirect Path Set', from.path);
        this.$store.dispatch('setRedirectPath', from.path);
      }
    },
    redirect(link) {
      this.show_drawer = false;
      this.$router.push(link);
    },
    closeDrawer() {
      this.show_drawer = false;
    },
    showDrawer() {
      this.show_drawer = true;
    },
    setDefaultTab() {
      this.defaultTab = (this.active_tabs[this.$route.path] && this.active_tabs[this.$route.path].activeTab) || '4';
    },
    gotoAccount() {
      if (this.disable_menu) return;
      this.$router.push('/account/info');
    },
    logout() {
      this.show_drawer = false;

      if (this.disable_menu) return;
      this.userProvider.logout();
      this.$store.dispatch('setRedirectPath', null);
      window.eventBus.$emit('hide-player');

      this.showSuccessMsg('You have beeen logged out!');
      this.removeMarginFromFooter();
      // this.$notify.success({
      //   message: 'You have beeen logged out!',
      // });
      this.$router.push('/listen');
    },
    navigateToMyAccount() {
      this.$router.push('/account/info');
    },
    hidePremiumButton() {
      this.hidden = this.$route.path.includes('signin') || this.$route.path.includes('signup');
    },
    disableNavigation() {
      return this.disabled_paths.includes(this.$route.path);
    },
    updateAppStyle() {
      const app = document.getElementById('app');
      if (app && !this.isLoggedIn && !this.isMarketingPage && window.screen.width <= 768) {
        if (app.classList.value.indexOf('auth-footer-visible') < 0) {
          app.classList.add('auth-footer-visible');
        }
      } else {
        app.classList.remove('auth-footer-visible');
      }
    },
    removeMarginFromFooter() {
      const app = document.getElementById('app');
      const body = document.querySelector('body');
      if (!app) return;
      app.classList.remove('audio-player-visible');
      body.classList.remove('audio-player-visible');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../assets/scss/variables.scss";
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  transition: .2s all ease-in-out;
  z-index: 9998;
}

.drawer {
  width: 277px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  transform: translateX(-100%);
  background-color: #fff;
  transition: 0.4s all ease-in-out;
  z-index: 9999;

  .logo {
    padding-left: 20px;
    margin-bottom: 30px;

    img {
      width: 100px;
    }
  }

  .sub-menu {
    position: relative;

    .link {
      padding: 10px 0 10px 20px;

      display: flex;
      align-items: center;

      color: $black;

      > .icon {
        margin-right: 5px;
      }

      > span {
        margin-top: 2px;
      }

      &:not(:last-child) {
        margin-bottom: 10px;
      }

      &.has-active-state {
        &.router-link-exact-active {
          > span {
            position: relative;
            &::after {
              content: '';

              height: 1px;
              width: calc(100% + 29px);

              position: absolute;
              top: calc(100% + 2px);
              left: -29px;

              background-color: $black;
            }
          }
        }
      }
    }

    &:not(:last-child) {
      padding-bottom: 20px;
      margin-bottom: 15px;

      &::after {
        content: '';
        position: absolute;

        top: 100%;
        left: 20px;

        width: 30px;
        height: 1px;

        background-color: #D8D8D8;
      }
    }
  }

  .cross {
    display: inline-block;
    padding: 20px 0 32px 16px;
    i {
      font-size: 24px;
    }
  }
}

.translate0 {
  transform: translateX(0);
}

.translate-100 {
  transform: translateX(-100%);
}

.disabled {
  pointer-events: none !important;
}

.el-dropdown-menu {
  min-width: 157px;
  height: 159px;
  border-radius: 10px;
  background-color: #fff;

  .el-dropdown-menu__item{
    font-size: 14px;
    line-height: 35px;
    margin: 16px 0px;
    color: $black;

    .arrow{
      float: right;
      font-size: 16px;
      color: $black;
      margin-left:10px;
      font-weight: 700 !important;
    }
  }
  .el-dropdown-menu__item:hover{
    color:$white !important;
    background-color: $black !important;
    .arrow {
      color:$white;
    }
  }
  .el-dropdown-menu__item a{
    color: inherit;
  }
}

.app-navbar {
  z-index: 998;
  height: 72px;
  min-height: 72px;
  padding: 6px 0;
  border-bottom: 1px solid #D4D4D4;
  box-sizing: border-box;
  position: relative;

  display: flex;
  align-items: center;

  .el-menu-item {
    color: $black;
    padding:0 0.25rem;
    line-height: 24px !important;
    height: auto;
    margin: 0 0 0 48px;
    padding: 0;
    // opacity: 0.7;
    * { vertical-align: baseline;  }

    img {
      width: 24px;
      margin-bottom: -5px;
    }

    .menu-text {
      font-size: 16px;
      font-family: Favorit;
    }

    &.is-active {
      opacity: 1;
      color: $black;
      border-color: $black;
      border-width: 1px;
    }

    &:hover {
      opacity: 1;
    }

    @media (max-width: 1024px) {
      margin: 0 0 0 24px;
    }
  }

  .el-menu-item:first-child {
    margin-left: 0px;
  }

  .profile-pic {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-top: 4px;
  }

  .el-menu--horizontal {
    border-bottom: none !important;
  }

  .f-r .is-active {
    border-bottom: 0 !important;
  }

  .user-avatar-menu {
    display: none;
    position: absolute;

    right: 0;
    top: 50%;
    transform: translateY(-50%);

    @media (max-width: 768px) {
      display: block;
    }
  }

  .user-avatar-menu, .user-avatar-menu-desktop {
    .el-dropdown-menu {
      transform: translateX(-100%);
      left: 45px !important;
      width: 200px !important;

      &__item {
        width: 100% !important;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        white-space: nowrap;

        &:first-child {
          position: relative;
          width: 100% !important;
          padding-right: 30px !important;

          span:last-child {
            position: absolute;
            top: 50%;
            right: 5px;

            transform: translateY(-50%);
            float: none;
          }
        }
      }
    }
  }

  .user-dropdown {
    .el-submenu__title {
      border-bottom: 2px solid transparent !important;
    }

    .account_img {
      border-radius: 50%;
      width: 2.5rem;
      height: 2.5rem;
    }

    .el-icon-arrow-down {
      display: none;
    }
  }

  .el-button {
    height: 40px;
  }

  .tabs-menu {
    margin-left: 45px;

    @media (max-width: 1024px) {
      margin-left: 30px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  > .container {
    display: flex;
    align-items: center;
    position: relative;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  .logo img {
    width: 136px;
    margin-top: 10px;

    @media (max-width: 567px) {
      width: 100px;
    }
  }

  .hamburger-menu {
    display: none;
    position: absolute;

    top: 50%;
    left: 0;

    transform: translateY(-50%);

    @media (max-width: 768px) {
      display: block;
      margin-left: -20px;
      padding: 0 20px;
    }
  }

  .right-menu {
    margin-left: auto;

    @media (max-width: 768px) {
      position: absolute;
      right: 0;

      .go-premium {
        display: none;
      }

      .listen {
        display: none;
      }
    }

    @media (max-width: 567px) {
      display: none;
    }
  }

  .link-menu {
    .link {
      color: $black;
      position: relative;

      &:not(:last-child) {
        margin-right: 25px;
      }

      &::after {
        content: '';

        position: absolute;

        top: 100%;
        left: 0;

        background-color: #00BEDE;
        opacity: 0;

        transition: opacity 250ms ease;

        height: 2px;
        width: 100%;
      }

      &:hover {
        &::after {
          opacity: 1;
        }
      }
    }

    &:not(:last-child) {
      margin-right: 60px;

      position: relative;

      &::after {
        content: '';

        position: absolute;
        height: 25px;
        width: 1px;

        background-color: #D8D8D8;

        top: 50%;
        left: calc(100% + 30px);
        transform: translateY(-50%);
      }
    }

    @media (max-width: 767px) {
      &:first-child {
        display: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// app/src/components/Navbar.vue